import type { CSSProperties, ReactNode } from 'react';

/**
 * Full-width flex scaffold injected by the shell around every mounted plugin.
 *
 * Plugin bundles commonly center content with `maxWidth` + `margin: '0 auto'`
 * without `width: '100%'`. Inside the shell's flex column that shrink-wraps to
 * content width (~card/spinner width). The shell owns this wrapper so plugins
 * do not each need a layout patch.
 *
 * Plugin authors: for chrome not in `<header>` / `<nav role="tablist">`, add
 * `data-plugin-chrome` (see `@experience/shared-ui` `pluginChromeProps()`).
 */
export function pluginPageRootStyle(): CSSProperties {
	return {
		width: '100%',
		alignSelf: 'stretch',
		minWidth: 0,
		flex: '1 1 auto',
		/* min-content: let the page size naturally; .emp-main scrolls. min-height:0
		   caused flex children (headers, tab bars) to be crushed to zero height. */
		minHeight: 'min-content',
		display: 'flex',
		flexDirection: 'column',
		boxSizing: 'border-box',
	};
}

export function PluginPageRoot({ children }: { children: ReactNode }) {
	return (
		<div data-plugin-page-root style={pluginPageRootStyle()}>
			{children}
		</div>
	);
}
